export const PM_BUTTON_GOLD =
  "bg-[#F5CB2B] text-[#613F4F] font-semibold hover:bg-[#4B303C] hover:text-white border-none";

export const PM_BUTTON_LINK =
  "text-[#613F4F] underline underline-offset-4 hover:opacity-80 border-none bg-transparent";

export const PM_ALERT_WARNING =
  "border-yellow-500/50 bg-yellow-500/10 text-yellow-900 dark:text-yellow-100 [&>svg]:text-yellow-700";

export const PM_BADGE_EFFECTIVATED =
  "border-transparent bg-[#F5CB2B] text-[#613F4F] hover:bg-[#F5CB2B]/90";

export const PM_TABLE_HEAD_PILL =
  "inline-flex items-center whitespace-nowrap rounded-full bg-[#4B303C] px-2.5 py-1 text-xs font-semibold text-white";

export const PM_BUCKET_BG = {
  best: "bg-[#14b8a6]",
  avg: "bg-[#4f6bd6]",
  eol: "bg-[#d9a300]",
  new: "bg-[#8a8a8a]",
  over: "bg-[#f97316]",
  slow: "bg-[#ef7a9a]",
  no: "bg-[#b2005b]",
} as const;

export const PM_TAB_TRIGGER =
  "rounded-none border-b-2 border-transparent bg-transparent px-1 pb-2 pt-0 text-sm font-medium text-muted-foreground shadow-none transition-colors data-[state=active]:border-[#4B303C] data-[state=active]:bg-transparent data-[state=active]:text-[#4B303C] data-[state=active]:shadow-none";

export const PM_TABS_LIST =
  "mb-3 h-auto w-full justify-start gap-6 rounded-none border-b bg-transparent p-0";

export const PM_TEXT_PRIMARY = "text-[#613F4F]";

export const PM_TEXT_PRIMARY_DARK = "text-[#4B303C]";

export const PM_PILL_MUTED = "border-muted bg-muted text-[#613F4F]";

export const PM_PILL_ACCENT = "border-[#4B303C] bg-[#4B303C] text-white";

export const PM_EMPTY_CELL_PATTERN =
  "bg-[repeating-linear-gradient(45deg,#f5f5f5_0,#f5f5f5_6px,#ffffff_6px,#ffffff_12px)]";

export const PM_BUTTON_CONFIRM_NEUTRAL =
  "bg-[#F5CB2B] text-[#613F4F] hover:bg-[#F5CB2B]/90";

export const PM_FOCUS_RING_PRIMARY_DARK = "focus-visible:ring-[#4B303C]";

export const PM_NEW_MARKDOWN_ACTION =
  "rounded-md border border-[#4B303C]/35 px-2.5 py-1 text-xs font-medium text-[#613F4F] transition-colors hover:border-[#4B303C] hover:bg-muted/40 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50";

export const PM_CHECKBOX_BOX = "border-[#4B303C] bg-white text-[#613F4F]";

export const PM_CHECKBOX_BOX_ON = "bg-[#F5CB2B] border-[#4B303C]";

export const PM_MARKING_PILL_BASE =
  "inline-flex items-center gap-1.5 whitespace-nowrap rounded-full border-[1.5px] px-2.5 py-1 text-xs font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4B303C] focus-visible:ring-offset-1";

export const PM_MARKING_PILL_OFF =
  "border-[#4B303C]/35 bg-transparent text-[#613F4F] hover:border-[#4B303C] hover:bg-[#4B303C]/5";

export const PM_XBAR_LINK =
  "inline-flex items-center gap-2 text-sm font-semibold text-[#613F4F] transition-colors hover:text-[#4B303C] disabled:cursor-not-allowed disabled:opacity-50";

export const PM_ROW_SELECTION_BAR = "rounded-xl border bg-[#F9FBFC] px-4 py-3";

export const PM_GROUP_ROW =
  "cursor-pointer border-t-2 border-[#4B303C]/20 bg-[#4B303C]/[0.06] font-semibold text-[#4B303C] hover:bg-[#4B303C]/10";

export const PM_GROUP_TOGGLE =
  "inline-flex items-center gap-2 rounded-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#4B303C] focus-visible:ring-offset-1";

export const PM_SUBGROUP_GUIDE =
  "inline-block border-l-2 border-[#4B303C]/25 py-0.5 pl-3 ml-4";

export const PM_NESTED_SUBGROUP_GUIDE =
  "inline-block border-l-2 border-[#4B303C]/25 py-0.5 pl-3 ml-10";

export const PM_ENTRIES_BAR = "bg-slate-500";

export const PM_BUDGET_UNDEFINED = "font-medium text-amber-700";

export const PM_ITEM_STATUS_BADGE_BASE =
  "inline-flex items-center whitespace-nowrap rounded-full border px-2 py-0.5 text-[11px] font-medium";

export const PM_AWAITING_APPLICATION_BADGE = `${PM_ITEM_STATUS_BADGE_BASE} border-sky-200 bg-sky-100 text-sky-700`;

export const PM_IN_MARKDOWN_BADGE = `${PM_ITEM_STATUS_BADGE_BASE} border-indigo-200 bg-indigo-100 text-indigo-700 underline-offset-2 hover:underline`;

export const PM_DISREGARDED_ITEM = "text-xs font-medium text-amber-700";

export const PM_LETTER_RELEASED_INFO = "text-xs text-muted-foreground";
